import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import ClearIcon from '@mui/icons-material/Clear';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ActionGroup from '../ActionGroup';
import Grid from '@mui/material/Grid';
import Modal from '../Modal';

function DeleteButton(props) {
  const [isOpen, setIsOpen] = React.useState(false);
  const onClick = () => {
    setIsOpen(true);
  };
  const onClickCancel = () => {
    props.onCancel?.();
    setIsOpen(false);
  };
  const onClickConfirm = () => {
    props.onConfirm?.();
    setIsOpen(false);
  };
  return (
    <>
      <Button
        color="primary"
        variant={ props.variant ?? "outlined" }
        title={props.title}
        style={{ padding: props.padding }}
        disabled={props.isFetching}
        onClick={onClick}
      >
        {props.isFetching ? (
          <CircularProgress sx={{color: 'inherit'}} size={24} />
        ) : (
            <><ClearIcon /> { props.text ?? null }</>
        )}
      </Button>
      <Modal
        open={isOpen}
        onClose={onClickCancel}
        header={ props.header ?? "Подтверждение удаления"}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography align="center">{props.message}</Typography>
          </Grid>
          <Grid item xs={12}>
            <ActionGroup align="right">
              <Button variant="contained" onClick={onClickCancel}>Отмена</Button>
              <Button variant="contained" color="error" onClick={onClickConfirm}>{props.yesText ?? "Удалить"}</Button>
            </ActionGroup>
          </Grid>
        </Grid>
      </Modal>
    </>
  );
}

export default DeleteButton;
